/*
Improvement Notes:
1) Error in iphone x mobile view horizontal line goes out of the area.
*/
import React from 'react'
// import { links, social } from './data'
import {
  FaBehance,
  FaFacebook,
  FaHome,
  FaLinkedin,
  FaMobile,
  FaPhone,
  FaEnvelope,
  FaTwitter,
  FaYoutube,
} from 'react-icons/fa'
const styleTxtDecNone = { 'text-decoration': 'none' }
const Footer = () => {
  return (
    <>
      <footer className='bg-light text-dark pt-5 pb-4'>
        <div className='container text-center text-md-left'>
          <div className='row text-center text-md-left'>
            <div className='col-md-3 mx-auto mt-3'>
              <h5 className='text-uppercase mb-4 font-weight-bold text-info'>
                About us
              </h5>
              <hr className='mb-4'></hr>
              <p>
                We are coming from different IT professional background from
                different industry. We have been working in German Tech
                industries for last 15 years and we want to bring our expertise
                and knowledge to help our clients.
              </p>
            </div>

            <div className='col-md-2 mx-auto mt-3'>
              <h5 className='text-uppercase mb-4 font-weight-bold text-info'>
                Quick Links
              </h5>
              <hr className='mb-4'></hr>
              <p>
                <a href='#' className='text-dark' style={styleTxtDecNone}>
                  Services
                </a>
              </p>
              <p>
                <a href='#' className='text-dark' style={styleTxtDecNone}>
                  About
                </a>
              </p>
              <p>
                <a href='#' className='text-dark' style={styleTxtDecNone}>
                  Contact
                </a>
              </p>
            </div>

            <div className='col-md-3 col-lg-2 mx-auto mt-3'>
              <h5 className='text-uppercase mb-4 font-weight-bold text-info'>
                Services
              </h5>
              <hr className='mb-4'></hr>
              <p>
                <a href='#' className='text-dark' style={styleTxtDecNone}>
                  Technical Recruitment
                </a>
              </p>
              <p>
                <a href='#' className='text-dark' style={styleTxtDecNone}>
                  Cloud Services
                </a>
              </p>
              <p>
                <a href='#' className='text-dark' style={styleTxtDecNone}>
                  Data Center
                </a>
              </p>
              <p>
                <a href='#' className='text-dark' style={styleTxtDecNone}>
                  Software Solution
                </a>
              </p>
            </div>

            <div className='col-md-4 col-lg-3 mx-auto mt-3'>
              <h5 className='text-uppercase mb-4 font-weight-bold text-info'>
                Contact Info
              </h5>
              <hr className='mb-4'></hr>
              <p>
                <i className='mr-3'>
                  <FaHome />
                </i>
                Street 1, Berlin 1234, Germany
              </p>
              <p>
                <i class='mr-3'>
                  <FaEnvelope />
                </i>
                engineering@cloudsicher.com
              </p>
              <p>
                <i className='fas mr-3'>
                  <FaPhone />
                </i>
                +4917662598768
              </p>
            </div>

            <div className='container'>
              <hr className='mb-4'></hr>
            </div>
            <div className='row d-flex justify-content-center'>
              <div className='text-center '>
                <p>
                  &copy;
                  <a href='#' style={styleTxtDecNone}>
                    <strong className='text-info'>Cloudsicher</strong>
                  </a>{' '}
                  {new Date().getFullYear()}
                </p>
              </div>
            </div>

            <div className='row d-flex justify-content-center'>
              <div className='text-center'>
                <ul className='list-unstyled list-inline'>
                  <li className='list-inline-item'>
                    <a href='#' className='text-dark'>
                      <FaFacebook size={18} className='mr-3' />
                    </a>
                  </li>
                  <li className='list-inline-item'>
                    <a href='#' className='text-dark'>
                      <FaYoutube size={18} className='mr-3' />
                    </a>
                  </li>
                  <li className='list-inline-item'>
                    <a href='#' className='text-dark'>
                      <FaLinkedin size={18} />
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* <ul className='aci'>
            {social.map((socialIcon) => {
              const { id, url, icon } = socialIcon
              return (
                <li key={id}>
                  <a href={url}>{icon}</a>
                </li>
              )
            })}
          </ul> */}
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer

{
  /* <footer className='bg-dark text-white pt-5 pb-4'>
  <div className='container text-center text-md-left'>
  </div>
</footer> */
}
